module.exports = __webpack_public_path__ + "p4_img3.jpg?3f6fbfc8d4beecb5262c2032eb0bcb3e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img3.jpg
// module id = 178
// module chunks = 0